import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import Drawer from '../ui/Drawer';
import './CartDrawer.css';

const CartDrawer: React.FC = () => {
  const navigate = useNavigate();
  const { items, isOpen, closeCart, itemCount, subtotalDisplay, removeItem, updateQuantity } = useCart();

  const handleCheckout = () => {
    closeCart();
    navigate('/checkout');
  };

  return (
    <Drawer open={isOpen} onClose={closeCart} side="right" label="Shopping cart">
      <div className="cart-drawer">
        {/* Header */}
        <div className="cart-drawer__header">
          <h2 className="cart-drawer__title">
            Cart {itemCount > 0 && <span className="cart-drawer__count">({itemCount})</span>}
          </h2>
          <button className="cart-drawer__close" onClick={closeCart} aria-label="Close cart">
            <CloseIcon />
          </button>
        </div>

        {/* Items */}
        {items.length === 0 ? (
          <div className="cart-drawer__empty">
            <p>Your cart is empty.</p>
          </div>
        ) : (
          <>
            <ul className="cart-drawer__items">
              {items.map((item) => (
                <li key={item.id} className="cart-line">
                  <div className="cart-line__image-wrap">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="cart-line__image"
                      width={72}
                      height={90}
                    />
                  </div>

                  <div className="cart-line__info">
                    <p className="cart-line__title">{item.title}</p>
                    <p className="cart-line__variant">{item.variantLabel}</p>

                    <div className="cart-line__footer">
                      {/* Quantity controls */}
                      <div className="cart-line__qty" role="group" aria-label={`Quantity for ${item.title}`}>
                        <button
                          className="cart-line__qty-btn"
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          aria-label="Decrease quantity"
                        >−</button>
                        <span className="cart-line__qty-val">{item.quantity}</span>
                        <button
                          className="cart-line__qty-btn"
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          aria-label="Increase quantity"
                        >+</button>
                      </div>

                      <span className="cart-line__price">
                        {item.quantity > 1
                          ? `${item.quantity} × ${item.priceDisplay}`
                          : item.priceDisplay}
                      </span>

                      <button
                        className="cart-line__remove"
                        onClick={() => removeItem(item.id)}
                        aria-label={`Remove ${item.title} from cart`}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            {/* Footer */}
            <div className="cart-drawer__footer">
              <div className="cart-drawer__subtotal">
                <span>Subtotal</span>
                <span>{subtotalDisplay}</span>
              </div>
              <p className="cart-drawer__note">Shipping and tax calculated at checkout.</p>

              <button
                className="cart-drawer__checkout-btn"
                onClick={handleCheckout}
              >
                Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default CartDrawer;
